import { StatsigClient } from '@statsig/js-client';
import Cookie from 'js-cookie';
import { window } from '../globals';

export default class StatsigService {
  public static async init(experiment: string, variation: string) {
    const uuid = Cookie.get('ysp_uuid');
    const sdkKey = window?.statsigClientSdk;

    if (!uuid) {
      throw new Error('Statsig Missing uuid');
    }

    if (!sdkKey) {
      throw new Error('Statsig has no client sdk key');
    }

    const myStatsigClient = new StatsigClient(sdkKey, {
      custom: {
        isMobile: window?.siteMetadata?.isMobile,
        site: window?.siteMetadata?.siteUrl,
      },
      userID: uuid,
    });

    const response = await myStatsigClient.initializeAsync();

    if (!response.success && response.error) {
      throw new Error(response.error.message);
    }

    if (response.success) {
      myStatsigClient.getExperiment(experiment);
      StatsigService.addClarityVariable(experiment, variation);
    }
  }

  private static addClarityVariable(experiment: string, variation: string) {
    if (window?.clarity) {
      window.clarity('set', 'statsig', `${experiment} - ${variation}`);
    }
  }
}
